import axios from 'axios';

const GetLeadsApi = () => {
	return axios.get('https://backend.planmyleisure.com/lead/get-leads');
};

export default GetLeadsApi;
